import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["thumb"]
  static values  = { controls: String }

  initialize() {
    this.onPointerMove = this.onPointerMove.bind(this)
    this.onPointerUp = this.onPointerUp.bind(this)
  }

  connect() {
    if (!this.controlsValue) {
      console.warn("[scrollbar] No controls value provided")
      return
    }
    const targetId = this.controlsValue
    this.scroller = document.getElementById(targetId)
    if (!this.scroller) {
      console.warn(`[scrollbar] Element #${targetId} not found`)
      return
    }

    this.scroller.style.overflowX = "auto"

    this.sync = () => this.updateThumb()
    this.scroller.addEventListener("scroll", this.sync)
    window.addEventListener("resize", this.sync)
    this.updateThumb()
  }

  disconnect() {
    if (!this.scroller) return
    this.scroller.removeEventListener("scroll", this.sync)
    window.removeEventListener("resize", this.sync)
  }

  updateThumb() {
    const { scrollWidth, clientWidth, scrollLeft } = this.scroller

    if (scrollWidth <= clientWidth) {
      this.element.hidden = true
      return
    }

    this.element.hidden = false
    const trackWidth = this.element.clientWidth
    const ratio = clientWidth / scrollWidth
    const thumbWidth = Math.max(ratio * trackWidth, 20)

    this.thumbTarget.style.width = `${thumbWidth}px`
    const maxLeft = trackWidth - thumbWidth
    const left = (scrollLeft / (scrollWidth - clientWidth)) * maxLeft || 0
    this.thumbTarget.style.left = `${left}px`

    this.element.setAttribute("aria-valuemin", 0)
    this.element.setAttribute("aria-valuemax", scrollWidth - clientWidth)
    this.element.setAttribute("aria-valuenow", scrollLeft)
  }

  pointerdown(e) {
    if (e.button !== 0) return
    this.dragging = true
    this.startX = e.clientX
    this.startScrollLeft = this.scroller.scrollLeft

    document.addEventListener("pointermove", this.onPointerMove)
    document.addEventListener("pointerup", this.onPointerUp)
  }

  onPointerMove(e) {
    if (!this.dragging) return
    const delta = e.clientX - this.startX
    const trackWidth = this.element.clientWidth
    const thumbWidth = this.thumbTarget.clientWidth
    const scrollRange = this.scroller.scrollWidth - this.scroller.clientWidth
    this.scroller.scrollLeft = this.startScrollLeft + (delta / (trackWidth - thumbWidth)) * scrollRange
  }

  onPointerUp() {
    this.dragging = false
    document.removeEventListener("pointermove", this.onPointerMove)
    document.removeEventListener("pointerup", this.onPointerUp)
  }

  click(e) {
    if (e.target === this.thumbTarget) return
    const rect = this.element.getBoundingClientRect()
    const clickX = e.clientX - rect.left
    const trackWidth = this.element.clientWidth
    const scrollRange = this.scroller.scrollWidth - this.scroller.clientWidth
    const targetLeft = (clickX / trackWidth) * scrollRange
    this.scroller.scrollTo({ left: targetLeft, behavior: "smooth" })
  }
}